import { DatePicker, Form, Input } from 'antd';

/** The four fields every compliance-document modal collects, shared across trucks/trailers/drivers (gitaumoses4/chukua#17) — rendered inside the parent's own `<Form>`. */
export function ComplianceDocumentFormFields() {
  return (
    <>
      <Form.Item name="number" label="Number" rules={[{ required: true, message: 'Enter the document number' }]}>
        <Input />
      </Form.Item>
      <Form.Item name="issuer" label="Issuer" rules={[{ required: true, message: 'Enter the issuer' }]}>
        <Input />
      </Form.Item>
      <Form.Item name="issueDate" label="Issue date" rules={[{ required: true, message: 'Select an issue date' }]}>
        <DatePicker className="w-full" />
      </Form.Item>
      <Form.Item name="expiryDate" label="Expiry date" rules={[{ required: true, message: 'Select an expiry date' }]}>
        <DatePicker className="w-full" />
      </Form.Item>
    </>
  );
}
